/**
 * bugReports.js — sorun bildirimi hook'ları.
 *
 *   POST  /bug-reports            (multipart: message, page_url, screenshot?)
 *   GET   /admin/bug-reports      (admin liste)
 *   PATCH /admin/bug-reports/{id} (admin durum)
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../services/apiClient';

export const bugReportKeys = {
  all: ['bugReports'],
  list: (status) => [...bugReportKeys.all, 'list', status ?? 'all'],
};

export function useSubmitBugReport() {
  return useMutation({
    mutationFn: ({ message, pageUrl, screenshot }) => {
      const fd = new FormData();
      fd.append('message', message);
      fd.append('page_url', pageUrl || '');
      if (screenshot) fd.append('screenshot', screenshot);
      return apiClient
        .post('/bug-reports', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then((r) => r.data);
    },
  });
}

export function useAdminBugReports(status) {
  return useQuery({
    queryKey: bugReportKeys.list(status),
    queryFn: () => {
      const q = status ? `?status=${status}` : '';
      return apiClient.get(`/admin/bug-reports${q}`).then((r) => r.data);
    },
    staleTime: 15_000,
  });
}

export function useUpdateBugReportStatus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status }) =>
      apiClient.patch(`/admin/bug-reports/${id}`, { status }).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: bugReportKeys.all }),
  });
}
